<div class="footer" [ngClass]="{nocta: noCta}">
  <div class="footer-cta" *ngIf="!noCta">
    <div class="footer-cta-container">
      <p class="semi-bold">{{'LANDING.FOOTER.CTA.TITLE' | translate}}</p>
      <button (click)="clickCta()" class="landing-button secondary filled">{{'LANDING.FOOTER.CTA.BUTTON' | translate}}</button>
    </div>
  </div>
  <div class="footer-info landing-section" [ngClass]="{nocta: noCta}">
    <div class="logo">
      <img src="assets/landing/images/footer-logo.png" alt="cargo logo" />
    </div>
    <!-- <div class="interest">
      <p class="semi-bold">{{'LANDING.FOOTER.INTEREST.TITLE' | translate}}</p>
      <p>{{'LANDING.FOOTER.INTEREST.I1' | translate}}</p>
      <p>{{'LANDING.FOOTER.INTEREST.I2' | translate}}</p>
      <p>{{'LANDING.FOOTER.INTEREST.I3' | translate}}</p>
    </div>
    <div class="categories">
      <p class="semi-bold">{{'LANDING.FOOTER.CATEGORIES.TITLE' | translate}}</p>
      <p>{{'LANDING.FOOTER.CATEGORIES.I1' | translate}}</p>
      <p>{{'LANDING.FOOTER.CATEGORIES.I2' | translate}}</p>
      <p>{{'LANDING.FOOTER.CATEGORIES.I3' | translate}}</p>
    </div>
    <div class="legal">
      <p class="semi-bold">{{'LANDING.FOOTER.LEGAL.TITLE' | translate}}</p>
      <p>{{'LANDING.FOOTER.LEGAL.I1' | translate}}</p>
      <p>{{'LANDING.FOOTER.LEGAL.I2' | translate}}</p>
    </div> -->
  </div>
  <div class="copyright">
    <!-- <p>Copyright © 2023 Rappi Inc. All rights reserved.</p> -->
  </div>
</div>